import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import {
  ClinicService,
  DEFAULT_TIMEZONE,
  getEligibilityStatusText,
  getPatientInsuranceStatusText,
  getTimeZone,
  PatientDataService,
  PatientInsurance,
  PatientInsuranceHistoryModel,
} from '@mmx/shared'
import { groupBy } from 'lodash'
import moment from 'moment-timezone'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Component({
  selector: 'mmx-patient-insurance-history-dialog',
  templateUrl: './patient-insurance-history-dialog.component.html',
  standalone: false,
})
export class PatientInsuranceHistoryDialogComponent implements OnInit {
  public tz = DEFAULT_TIMEZONE

  public history$!: Observable<{ date: moment.Moment, logs: PatientInsuranceHistoryModel[] }[]>
  public getEligibilityStatusText = getEligibilityStatusText
  public getPatientInsuranceStatusText = getPatientInsuranceStatusText

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { insurance: PatientInsurance },
    public patientDataService: PatientDataService,
    private clinicService: ClinicService,
  ) {}

  public ngOnInit() {
    this.tz = getTimeZone(this.clinicService.clinic)
    this.history$ = this.patientDataService.loadInsuranceHistory(this.data?.insurance).pipe(
      map((logs) => {
        const grouped = groupBy(
          logs || [],
          (log) => moment.tz(log.createdAt, this.tz).format('YYYY-MM-DD'),
        )
        return Object.entries(grouped).map(([date, dayLogs]) => ({
          date: moment.tz(date, this.tz),
          logs: dayLogs,
        }))
      }),
    )
  }

  public getActorName(log: PatientInsuranceHistoryModel): string {
    if (log.actor?.clinician?.name) {
      return log.actor.clinician.name
    }

    switch (log.actor?.type) {
      case 'patientpal':
        return 'System'
      case 'clinician':
        return 'Clinician'
      default:
        return 'Unknown Actor'
    }
  }

  public getHistoryTypeName(type?: string): string {
    if (!type) {
      return 'Unknown'
    }

    return type
      .replace(/[_\.]+/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase())
  }

  public isDate(value: any): boolean {
    return value != null && !isNaN(new Date(value).getTime())
  }
}
